import { fetchSnippetsForProductNumberList, prepareSnippetsForDOMInsertion } from './product-snippets';
import { initClickTracking } from './click-tracking';

document.addEventListener('DOMContentLoaded', function()
{
    if (!document.querySelector('#home'))
    {
        return;
    }

    let heroSlider = tns ({
        container: '.hero-slider',
        navContainer: '.hero-slider-nav',
        center: true,
        items: 1,
        speed: 300,
        controlsText: ['', ''],
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        autoplayButtonOutput: false,
    });

    tns ({
        container: '.new-slider',
        items: 2,
        speed: 300,
        controlsText: ['', ''],
        nav: false,
        loop: false,
        responsive: {
            768: {
                items: 3
            },
            1150: {
                items: 4
            },
            1400: {
                items: 5
            }
        }
    });

    document.querySelectorAll('.js-bestseller-slider').forEach(slider =>
    {
        tns({
            container: slider,
            items: 2,
            speed: 300,
            controlsText: ['', ''],
            nav: false,
            loop: false,
            responsive: {
                768: {
                    items: 3
                },
                1150: {
                    items: 4
                },
                1400: {
                    items: 5
                }
            }
        });
    });

    tns ({
        container: '.sale-slider',
        items: 2,
        speed: 300,
        controlsText: ['', ''],
        nav: false,
        loop: false,
        responsive: {
            768: {
                items: 3
            },
            1150: {
                items: 4
            },
            1400: {
                items: 5
            }
        }
    });

    tns ({
        container: '.label-slider',
        items: 2,
        slideBy: 2,
        lazyload: true,
        speed: 300,
        controlsText: ['', ''],
        nav: false,
        responsive: {
            450: {
                items: 6,
                slideBy: 6
            }
        }
    });

    let slides = document.querySelectorAll('.hero-slider .tns-item[id^="tns1-item"]');
    let processedSlides = [];

    function initHeroSlider()
    {
        loadHeroSlide(slides[0]);
        loadHeroSlide(slides[1]);
        loadHeroSlide(slides[slides.length - 1]);
    }

    function lazyLoadHeroSlides(slide)
    {
        let currentSlideIndex = slide.index - 1 < 0
            ? slides.length - 1
            : slide.index - 1 > slides.length - 1 ? 0 : slide.index - 1;
        let nextSlideIndex = currentSlideIndex + 1 > slides.length - 1 ? 0 : currentSlideIndex + 1;
        let prevSlideIndex = currentSlideIndex - 1 < 0 ? slides.length - 1 : currentSlideIndex - 1;

        loadHeroSlide(slides[currentSlideIndex]);
        loadHeroSlide(slides[nextSlideIndex]);
        loadHeroSlide(slides[prevSlideIndex]);
    }

    function loadHeroSlide(slide)
    {
        if (!processedSlides.includes(slide))
        {
            let slideSrc = slide.querySelector('img');
            let slideSrcSets = slide.querySelectorAll('source');
            let slideFlag = slide.querySelector('.heroteaser-flag');

            slideSrcSets.forEach((source) =>
            {
                source.setAttribute('srcset', source.getAttribute('data-lazy-srcset'));
                source.removeAttribute('data-lazy-srcset');
            });

            slideSrc.setAttribute('src', slideSrc.getAttribute('data-lazy-src'));
            slideSrc.removeAttribute('data-lazy-src');

            processedSlides.push(slide);

            if (slideFlag)
            {
                slideFlag.classList.remove('hidden-mobile');
            }
        }
    }

    heroSlider.events.on('indexChanged', lazyLoadHeroSlides);

    initHeroSlider();

    function initRecentlyViewedProducts()
    {
        const section = document.querySelector('.js-recently-viewed-products');
        const container = document.querySelector('.js-recently-viewed-products-container');
        const productHistory = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];

        fetchSnippetsForProductNumberList(productHistory.reverse(), 10)
            .then(response => response.json()).then(snippets =>
            {
                if (snippets[0].snippets.length >= 3)
                {
                    snippets[0].snippets.forEach(snippet =>
                    {
                        const element = prepareSnippetsForDOMInsertion(snippet, 'Home Recently Viewed');

                        container.appendChild(element);
                    });

                    initRecentlyViewedProductsSlider();

                    section.classList.remove('hidden');

                    // Workaround to queue the trigger and init into the next event loop
                    // to execute it AFTER every script inside the snippets is finished
                    setTimeout(() =>
                    {
                        $('#content').trigger(orion.constants.EventProductListReloaded);

                        initClickTracking();
                    }, 0);
                }
            });
    }

    function initRecentlyViewedProductsSlider()
    {
        tns ({
            container: '.js-recently-viewed-products-container',
            items: 2,
            speed: 300,
            loop: false,
            controlsText: ['', ''],
            nav: false,
            responsive: {
                768: {
                    items: 3
                },
                1150: {
                    items: 4
                },
                1400: {
                    items: 5
                }
            }
        });
    }

    initRecentlyViewedProducts();
});
